import React, { useEffect, useState } from 'react';
import './ExtendedForecast.css';
import en from '../../../../language/en/ForecastByMunicipalities.json';
import es from '../../../../language/es/ForecastByMunicipalities.json';
import {
	Container, Grid, makeStyles, Paper, Typography,
	TableContainer, Table, TableBody, TableCell, TableHead, TableRow
} from '@material-ui/core';
// import Pagination from '@material-ui/lab/Pagination';
import config from '../../../../config/config.json';

/* Recharts */
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Bar, Legend } from 'recharts';

import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: theme.spacing(2),
	},
	title: {
		marginBottom: theme.spacing(2),
		fontWeight: 'bold',
	},
	subTitle: {
		marginBottom: theme.spacing(1),
	},
	large: {
		width: theme.spacing(10),
		height: theme.spacing(10),
	},
	comentario: {
		marginBottom: theme.spacing(3),
	},
	table: {
		width: '100%',
	},
	tableContainer: {
		maxHeight: 1000
	},
	grapSurface: {
		backgroundColor: 'transparent',
	}
}));

export default function ExtendedForecast({ lang }) {
	// const [count, setCount] = useState(0);
	const [pronExt, setPronExt] = useState([null, null, null, null]);
	const [grapWith, setGrapWith] = useState(400/* window.screen.width - 100 */);
	const classes = useStyles();
	// const [page, setPage] = useState(1);
	const [rows, setRows] = useState([])
	// let rows = [];
	useEffect(() => {
		// side effects
		document.title = `CMP | Pronóstico del Tiempo`;
		window.scrollTo(0, 0);
	}, [])

	useEffect(() => {
		// side effects
		const url = `${config.apiBaseUrl}/pronostico/pronextendido/5`;

		//Obteniendo el pronóstico provincial
		fetch(url)
			.then(
				res => {
					return res.json();
				}
			)
			.then(
				data => {
					const result = Object.assign(...Object.keys(data[0]).map(key =>
						({ [key]: data.map(o => o[key]) })
					));

					console.log('pronostico extendido = ', result, Object.entries(result));
					setPronExt(data.sort((mun1, mun2) => mun1.id - mun2.id));

					let newRows = [];
					for (const key in result) {
						if (Object.hasOwnProperty.call(result, key)) {
							if (key != 'id' && key != 'meteorologo' && key != 'fiabilidad' && key != 'comentario' && key != 'mar' && key != 'luna') {
								const element = result[key];

								newRows.push([key.charAt(0).toUpperCase() + key.slice(1), ...element]);
							}
						}
					}
					console.log('element', newRows);
					setRows(newRows);
				}
			)
			.catch(
				err => {
					console.log("error ", err);
				}
			);

		// cleanup
		return () => {

		}
	}, [])

	// useEffect(() => {
	// 	let auxRows = [
	// 		{ nombreVar: 'Temperatura mín', valor: pronExt[page - 1].tempMin, unidadDeMedida: 'ºC' },
	// 		{ nombreVar: 'Temperatura máx', valor: pronExt[page - 1].tempMax, unidadDeMedida: 'ºC' },
	// 		{ nombreVar: 'Temperatura amb', valor: pronExt[page - 1].tempAmb, unidadDeMedida: 'ºC' },
	// 		{ nombreVar: 'Humedad', valor: pronExt[page - 1].humedad, unidadDeMedida: '%' },
	// 		{ nombreVar: 'Presión', valor: pronExt[page - 1].presion, unidadDeMedida: 'hP' },
	// 		{ nombreVar: 'Precipitación', valor: pronExt[page - 1].precipitaciones, unidadDeMedida: 'mm' },
	// 		{ nombreVar: 'Viento mín', valor: pronExt[page - 1].vientoMin, unidadDeMedida: 'km' },
	// 		{ nombreVar: 'Viento máx', valor: pronExt[page - 1].vientoMax, unidadDeMedida: 'km' },
	// 		{ nombreVar: 'Dirección viento', valor: pronExt[page - 1].dir_viento, unidadDeMedida: '-' },
	// 		{ nombreVar: 'Nubosidad', valor: pronExt[page - 1].nubosidad, unidadDeMedida: '1/8?' },
	// 		{ nombreVar: 'Mar', valor: pronExt[page - 1].mar, unidadDeMedida: '-' },
	// 		{ nombreVar: 'Luna', valor: pronExt[page - 1].luna, unidadDeMedida: '-' },
	// 		{ nombreVar: 'Visibilidad', valor: pronExt[page - 1].visibilidad, unidadDeMedida: 'km' },
	// 		{ nombreVar: 'Salida del Sol', valor: pronExt[page - 1].salidaSol, unidadDeMedida: '-' },
	// 		{ nombreVar: 'Puesta del Sol', valor: pronExt[page - 1].puestaSol, unidadDeMedida: '-' },
	// 	];
	// 	setRows(auxRows);
	// 	return () => {
	// 		// cleanup
	// 	}
	// }, [pronExt[page - 1]])

	// const handlePaginationChange = (event, value) => {
	// 	setPage(value);
	// }

	return (
		<div className="ExtendedForecast" lang={lang}>
			<div className="heading">
				<Typography variant="h4" color="secondary" className="efecto-espejo">
					Pronóstico Extendido
				</Typography>
			</div>
			<main>
				<Container >
					{/* <h1 onClick={() => setCount(count + 1)}>Hola ExtendedForecast!!! your language is '{lang}'.</h1> */}
					<Grid container spacing={5}>
						<Grid item container spacing={2} >

							{/* Pronostico comentado */}
							{/* <Grid item sm={7} xs={12}>
								<Paper className={classes.paper} elevation={2} style={{ minHeight: '560px' }}>
									<Typography className={classes.title} variant="h5" color="textPrimary" align="center" >
										Grupo de Pronósticos, CMP Santiago de Cuba.<br />
										Pronóstico del tiempo válido para el {pronExt[page - 1].fecha}
									</Typography>

									<Typography variant="subtitle1" color="initial" className={classes.comentario}>
										{pronExt[page - 1].comentario}
									</Typography>

									<Grid container spacing={1} direction="column" justify="center" alignItems="flex-end" xs={11}>
										<Grid item >
											<Avatar alt={pronExt[page - 1].meteorologo} src={`assets/files/avatar/gpmm/${pronExt[page - 1].meteorologo}.png`} className={classes.large} style={{}} />
										</Grid>
										<Grid item>
											<Typography variant="subtitle1" color="primary">{pronExt[page - 1].meteorologo}</Typography>
										</Grid>
									</Grid>

								</Paper>
							</Grid>

							<Grid item sm={1} xs={12}>
								{/* relleno /}
							</Grid> */}

							<Grid item sm={12} xs={12}>
								<Typography variant="h6" color="textSecondary" align="center" className={classes.subTitle}>
									Tabla
								</Typography>
								<TableContainer component={Paper} className={classes.tableContainer}>
									{/* <Typography style={{ fontWeight: 'bold' }} variant="subtitle1" color="textPrimary" align="center" >
										Variables Pronosticadas
									</Typography> */}
									<Table className={classes.table} aria-label="simple table">
										<TableHead>
											<TableRow>
												<TableCell align="center">Fecha</TableCell>
												<TableCell align="center">Nubosidad</TableCell>
												<TableCell align="center">Temp. max/min</TableCell>
												<TableCell align="center">Precip.</TableCell>
												<TableCell align="center">Viento</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{
												pronExt.map((row, index) => {
													return row ?
														(<TableRow key={row[0]}>
															<TableCell align="center">
																{row.fecha ? row.fecha.split('-').join('/') : 'dd/mm/yyyy'}
																{/* {row[0]} */}
															</TableCell>
															<TableCell align="center">
																<img src={`assets/files/pron/${row.nubosidad}.png`} title={row.nubosidad} alt={row.nubosidad} />
																{/* {row[1]} */}
															</TableCell>
															<TableCell align="center">
																<strong className="temp temp-max">{row.tempMax}º</strong>
																<span className="temp temp-separator"> / </span>
																<span className="temp temp-min">{row.tempMin}º</span>
																{/* {row[2]} */}
															</TableCell>
															<TableCell align="center">
																<img src={`assets/files/pron/${row.precipitaciones}.png`} title={row.precipitaciones} alt={row.precipitaciones} />
																{/* {row[3]} */}
															</TableCell>
															<TableCell align="center">
																{(row.dir_viento === 'VRB') ? 'Variable' : <>({row.vientoMin} - {row.vientoMax}) km/h <img src={`assets/files/pron/${row.dir_viento}.png`} title={row.dir_viento} alt={row.dir_viento} style={{ marginLeft: 10 }} /></>}
																{/* {row[4]} */}
															</TableCell>
														</TableRow>
														) :
														(<TableRow key={index}>
															<TableCell align="center">
																<Skeleton variant="text" width={20} /> / <Skeleton variant="text" width={20} /> / <Skeleton variant="text" width={20} />
															</TableCell>
															<TableCell align="center">
																<Skeleton variant="circle" width={64} height={64} />
															</TableCell>
															<TableCell align="center">
																<span className="temp temp-max"><Skeleton variant="text" width={30} />º</span>
																<span className="temp temp-separator"> / </span>
																<span className="temp temp-min"><Skeleton variant="text" width={30} />º</span>
															</TableCell>
															<TableCell align="center">
																<Skeleton variant="circle" width={64} height={64} />
															</TableCell>
															<TableCell align="center" className="v-align-middle">
																(<Skeleton variant="text" width={20} /> - <Skeleton variant="text" width={20} />) <Skeleton variant="text" width={30} /> <Skeleton variant="circle" width={50} height={50} />
															</TableCell>
														</TableRow>)
												})
											}
										</TableBody>
									</Table>
								</TableContainer>

							</Grid>

						</Grid>

						{/* <Grid
							item
							container
							direction="column"
							justify="center"
							alignItems="center"
							alignContent="center"
							wrap="nowrap"

						>
							<Typography variant="subtitle1" color="initial">
								Pronóstico para los próximos días.
							</Typography>
							<Pagination count={pronExt.length} page={page} onChange={handlePaginationChange} /* variant="outlined" / shape="rounded" color="primary" />
						</Grid> */}

					</Grid>

				</Container>

				<Container >
					{/* Tabla con el pronostico extendido */}
					{/* <Typography variant="h4" color="textPrimary" align="center" style={{ margin: '50px 0 8px' }}>
						Pronóstico extendido
					</Typography> */}
					{/* <Typography variant="subtitle1" color="textSecondary" align="center">
						Tabla
					</Typography>
					<Grid
						container
						spacing={1}
						direction="row"
						justify="center"
						alignItems="center"
						alignContent="stretch"
					// wrap="nowrap"

					>
						<Grid item md={2} sm={5} xs={11} >
							<Paper elevation={4} className={classes.paper} style={{ textAlign: 'center' }}>
								<Typography variant="subtitle1" className={classes.title} >
									{pronExt[0].fecha}
								</Typography>
								<Grid item container direction="column">
									<Grid item container justify="center" alignItems="center">
										<img src={`assets/files/pron/${pronExt[0].nubosidad}.png`} title={pronExt[0].nubosidad} />
										<div style={{ marginLeft: '8px' }}>
											<span style={{ fontSize: '1.5rem' }}>{pronExt[0].tempAmb}º</span>
											<p style={{ fontSize: '1rem' }}>{pronExt[0].tempMax + 'º / ' + pronExt[0].tempMin}º</p>
										</div>
										{/* <ListItemText primary={pronExt[0].tempAmb} secondary={pronExt[0].tempMax + '/' + pronExt[0].tempMin} /> /}
									</Grid>
								</Grid>
							</Paper>
						</Grid>
						<Grid item md={2} sm={5} xs={11} >
							<Paper elevation={4} className={classes.paper} style={{ textAlign: 'center' }}>
								<Typography variant="subtitle1" className={classes.title} >
									{pronExt[1].fecha}
								</Typography>
								<Grid item container direction="column">
									<Grid item container justify="center" alignItems="center">
										<img src={`assets/files/pron/${pronExt[1].nubosidad}.png`} title={pronExt[1].nubosidad} />
										<div style={{ marginLeft: '8px' }}>
											<span style={{ fontSize: '1.5rem' }}>{pronExt[1].tempAmb}º</span>
											<p style={{ fontSize: '1rem' }}>{pronExt[1].tempMax + 'º / ' + pronExt[1].tempMin}º</p>
										</div>
										{/* <ListItemText primary={pronExt[1].tempAmb} secondary={pronExt[1].tempMax + '/' + pronExt[1].tempMin} /> /}
									</Grid>
								</Grid>
							</Paper>
						</Grid>
						<Grid item md={2} sm={5} xs={11} >
							<Paper elevation={4} className={classes.paper} style={{ textAlign: 'center' }}>
								<Typography variant="subtitle1" className={classes.title} >
									{pronExt[2].fecha}
								</Typography>
								<Grid item container direction="column">
									<Grid item container justify="center" alignItems="center">
										<img src={`assets/files/pron/${pronExt[2].nubosidad}.png`} title={pronExt[2].nubosidad} />
										<div style={{ marginLeft: '8px' }}>
											<span style={{ fontSize: '1.5rem' }}>{pronExt[2].tempAmb}º</span>
											<p style={{ fontSize: '1rem' }}>{pronExt[2].tempMax + 'º / ' + pronExt[2].tempMin}º</p>
										</div>
										{/* <ListItemText primary={pronExt[2].tempAmb} secondary={pronExt[2].tempMax + '/' + pronExt[2].tempMin} /> /}
									</Grid>
								</Grid>
							</Paper>
						</Grid>
						<Grid item md={2} sm={5} xs={11} >
							<Paper elevation={4} className={classes.paper} style={{ textAlign: 'center' }}>
								<Typography variant="subtitle1" className={classes.title} >
									{pronExt[3].fecha}
								</Typography>
								<Grid item container direction="column">
									<Grid item container justify="center" alignItems="center">
										<img src={`assets/files/pron/${pronExt[3].nubosidad}.png`} title={pronExt[3].nubosidad} />
										<div style={{ marginLeft: '8px' }}>
											<span style={{ fontSize: '1.5rem' }}>{pronExt[3].tempAmb}º</span>
											<p style={{ fontSize: '1rem' }}>{pronExt[3].tempMax + 'º / ' + pronExt[3].tempMin}º</p>
										</div>
										{/* <ListItemText primary={pronExt[3].tempAmb} secondary={pronExt[3].tempMax + '/' + pronExt[3].tempMin} /> /}
									</Grid>
								</Grid>
							</Paper>
						</Grid>

					</Grid> */}


					<Typography variant="h6" color="textSecondary" align="center" style={{ margin: '50px 0 8px' }}>
						Gráficos
					</Typography>
					{/* Charts */}
					<Grid
						container
						spacing={5}
						direction="row"
						justify="center"
						alignItems="flex-start"
						alignContent="stretch"
					// wrap="nowrap"

					>
						<Grid item >
							<Paper elevation={0} className={classes.grapSurface}>
								<LineChart width={grapWith} height={200} data={pronExt} >
									<CartesianGrid stroke="#ccc" />
									<XAxis dataKey="fecha" />
									<YAxis />
									<Tooltip />
									<Legend />
									<Line type="monotone" dataKey="tempMax" stroke="#c51162" strokeWidth={3} />
									{/* <Line type="natural" dataKey="tempAmb" stroke="#304151" /> */}
									<Line type="monotoneX" dataKey="tempMin" stroke="#5d39a2" strokeWidth={3} />
								</LineChart>
							</Paper>
						</Grid>

						<Grid item>
							<Paper elevation={0} className={classes.grapSurface}>
								<LineChart width={grapWith} height={200} data={pronExt} >
									<CartesianGrid stroke="#ccc" />
									<XAxis dataKey="fecha" />
									<YAxis />
									<Tooltip />
									<Legend />
									<Line type="monotone" dataKey="presion" stroke="#3FB8AFaa" strokeWidth={3} />
								</LineChart>
							</Paper>
						</Grid>

						<Grid item >
							<Paper elevation={0} className={classes.grapSurface}>
								<LineChart width={grapWith} height={200} data={pronExt} >
									<CartesianGrid stroke="#ccc" />
									<XAxis dataKey="fecha" />
									<YAxis />
									<Tooltip />
									<Legend />
									<Line type="monotone" dataKey="humedad" stroke="#1976d2aa" strokeWidth={3} />
								</LineChart>
							</Paper>
						</Grid>

						<Grid item >
							<Paper elevation={0} className={classes.grapSurface}>
								<LineChart width={grapWith} height={200} data={pronExt} >
									<CartesianGrid stroke="#ccc" />
									<XAxis dataKey="fecha" />
									<YAxis />
									<Tooltip />
									<Legend />
									<Line type="monotone" dataKey="vientoMax" stroke="#f33" strokeWidth={3} />

									<Line type="natural" dataKey="vientoMin" stroke="#33f" strokeWidth={3} />
								</LineChart>
							</Paper>
						</Grid>

					</Grid>

				</Container>
			</main>
		</div>
	)
};